import { createToolStore } from './create-tool-store'

export const useBackgroundRemoverStore = createToolStore()
